import { Trans } from '@lingui/react/macro';

import { useCompanyKpiMetrics } from '@/api/activity';
import { KpiMetric, KpiMetricGroup } from '@/components/kpi';
import { usePageFilterContext } from '@/components/page';
import { numberFormat } from '@/helper/numberFormatter';
import { ROUTES } from '@/router';

type Props = {
  companyId?: string;
};

const CompanyDetailKPIMetrics = ({ companyId }: Props) => {
  const {
    pageFilters: { startDate, endDate },
  } = usePageFilterContext();
  const {
    companyKpiMetrics: data,
    isLoading,
    error,
  } = useCompanyKpiMetrics(companyId, startDate, endDate);

  return (
    <KpiMetricGroup>
      <KpiMetric
        label={<Trans>Open Opportunities</Trans>}
        value={data && numberFormat(data?.pipelineOpportunities)}
        valueLink={
          data?.pipelineOpportunities &&
          ROUTES.opportunityActivityWithParams({
            'o.companyId': companyId,
            'o.status': 'PIPELINE',
          })
        }
        isLoading={isLoading}
        error={error}
      />
      <KpiMetric
        label={<Trans>Closed Won Opportunities</Trans>}
        value={data && numberFormat(data?.closedWonOpportunities)}
        valueLink={
          data?.closedWonOpportunities &&
          ROUTES.opportunityActivityWithParams({
            'o.companyId': companyId,
            'o.status': 'CLOSED_WON',
          })
        }
        isLoading={isLoading}
        error={error}
      />
      <KpiMetric
        label={<Trans>Visits</Trans>}
        value={data && numberFormat(data?.visits)}
        isLoading={isLoading}
        error={error}
      />
      <KpiMetric
        label={<Trans>Non-Digital Events</Trans>}
        value={data && numberFormat(data?.opportunityCountNonDigitalEvents)}
        isLoading={isLoading}
        error={error}
      />
      <KpiMetric
        label={<Trans>Vendors</Trans>}
        value={data && numberFormat(data?.vendorCount)}
        isLoading={isLoading}
        error={error}
      />
    </KpiMetricGroup>
  );
};

export default CompanyDetailKPIMetrics;
